import h from 'hyperscript';

import type { ViewDto } from 'cadenza/workbook/api/view-dto';
import type { ConditionId } from 'cadenza/workbook/model/condition-id.gen';
import { AffectedViewTile } from 'cadenza/workbook/workbook-panel/analysis-context/affected-view-tile/affected-view-tile';
import { compareViewByRowAndColumn } from 'cadenza/workbook/workbook-utils';

import './affected-views-flyout.css';
import i18n from './affected-views-flyout.properties';

const COMPONENT_NAME = 'd-affected-views-flyout';

export class AffectedViewsFlyout extends HTMLElement {
  readonly #views: ViewDto[];
  readonly #viewsWithLocalConditions?: ViewDto[];
  readonly #conditionId?: ConditionId;

  constructor(views: ViewDto[], viewsWithLocalConditions?: ViewDto[], conditionId?: ConditionId) {
    super();
    this.#views = views;
    this.#viewsWithLocalConditions = viewsWithLocalConditions;
    this.#conditionId = conditionId;
  }

  connectedCallback() {
    const content = [];
    if (this.#views.length === 0 && this.#viewsWithLocalConditions?.length === 0) {
      this.append(h('d-alert.d-alert-small.d-alert-info', i18n('affected-views-flyout.no-content')));
    }

    if (this.#views.length) {
      this.#views.sort(compareViewByRowAndColumn);
      content.push(
        h('p.header', h('b', i18n('affected-views-flyout.header'))),
        h(
          '.affected-views',
          this.#views.map((view) => new AffectedViewTile(view, this.#conditionId)),
        ),
      );
    }
    if (this.#viewsWithLocalConditions?.length) {
      this.#viewsWithLocalConditions.sort(compareViewByRowAndColumn);
      content.push(
        h(
          'p.header.affected-views--with-local-conditions',
          h('b', i18n('affected-views-flyout.header.diverging-filters')),
        ),
        h(
          '.affected-views',
          this.#viewsWithLocalConditions.map((view) => new AffectedViewTile(view, this.#conditionId)),
        ),
      );
    }
    this.append(...content);
  }
}

customElements.define(COMPONENT_NAME, AffectedViewsFlyout);
